import React from 'react';

import { WorkActivity, WorkActivityStatus } from '@/services/types/work-activity.types';
import workActivityPrimaryIcon from '@/assets/icons/work-activity-preview.svg';
import workActivityPendingIcon from '@/assets/icons/work-activity-pending.svg';
import workActivityRejectedIcon from '@/assets/icons/work-activity-rejected.svg';
import workActivityAcceptedIcon from '@/assets/icons/work-activity-accepted.svg';
import {
  formatWorkActivityTableAmount,
  getWorkActivityAmount,
  getWorkActivityStatusLabel
} from '@/utils/workActivityForm';

interface WorkActivityPreviewProps {
  workActivity: WorkActivity;
  currency?: string;
}

const STATUS_ICONS: Record<WorkActivityStatus, string> = {
  PENDING: workActivityPendingIcon,
  REJECTED: workActivityRejectedIcon,
  APPROVED: workActivityAcceptedIcon
};

const WorkActivityPreview = ({ workActivity, currency = 'EUR' }: WorkActivityPreviewProps) => {
  const amount = getWorkActivityAmount(workActivity);

  return (
    <div className="bg-lightPurple rounded-[16px] p-6 px-0 pt-0">
      <div className="flex flex-col items-center justify-center px-6 pb-4">
        <img src={workActivityPrimaryIcon} alt="work-activity-icon" className="inline-block -mt-10 " />
        <p className="text-[32px] font-semibold leading-[115%]">{formatWorkActivityTableAmount(amount, currency)}</p>
        <p className="text-lg font-semibold">{workActivity.activity}</p>
      </div>

      <div className="h-[1px] bg-[#DEE2E6] w-full" />

      <div className="pt-4 px-6">
        <div className="flex items-center justify-between gap-2">
          <span className="text-xs text-secondary font-medium">Status</span>
          <div className="flex items-center gap-1">
            <img src={STATUS_ICONS[workActivity.status]} alt="" className="w-4 h-4" />
            <p className="text-sm font-medium">{getWorkActivityStatusLabel(workActivity.status)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkActivityPreview;
